<template lang="">
    <main class="performaceResult container-fluid mf_container pb_50 mb_50">
        <div v-show="is_ready">
            <h4 class="text-green mt_22">業績換算結果</h4>
            <h4 class="text-red mt_10">本系統換算結果僅為估算參考，可能會因獎懲、受理日期、舉績工作月等因素而不同，實際核發數字請以外務系統為準。</h4>
            <!-- 結果表格 -->
            <div  v-if="!isLoading" class="performaceNewResultItem">
                <div class="performaceNewResultItem__header">舉績年月(工作月): {{userWorkDate}}</div>
                <div class="performaceNewResultItem__title">
                    <div>建議書<br />編號</div>
                    <div>商品名稱</div>
                    <div>
                        <div>業績FYP</div>
                        <div class="text_colum">
                            <div>表定</div>
                            <div>加成後</div>
                        </div>
                    </div>
                    <div>
                        <div>{{userPosition  ? '業績FYC': '當工業績分數'}}</div>
                        <div class="text_colum">
                            <div>表定</div>
                            <div>加成後</div>
                        </div>
                    </div>
                    <div>
                        <div>{{userPosition ? '業務津貼': '工作獎金'}}</div>
                        <div class="text_colum">
                            <div>表定</div>
                            <div class="word_length">加發獎勵金</div>
                        </div>
                    </div>
                </div>
                <!-- 內容 -->
                <div  class="performaceNewResultItem__row" v-for="data in proposalData" :key="data.NO">
                    <div class="table">
                        <div class="number_border">{{"NO."+ data.NO }}</div>
                        <div class="layout">
                            <div class="contact" v-for="item in data.mc_prod_list" :key="item.mc_idx">
                                <div> {{"建議"+ item.order + "  "+item.total_real_premium_str+ " " + formatMethods(item.total_real_premium)+" "+ item.curr_nm}}</div>
                                <div class="main">
                                    <div>{{item.prod_name+"("+item.prod_id+")"}}</div>  
                                    <div>{{formatMethods(item.ori_fyp)}}</div>
                                    <div>{{formatMethods(item.incent_fyp)}}</div>
                                    <div>{{userPosition ? formatMethods(item.ori_pfm_c): formatMethods(item.ori_scr)}}</div>
                                    <div>{{userPosition ? formatMethods(item.incent_pfm_c): formatMethods(item.incent_scr)}}</div>
                                    <div>{{formatMethods(item.ori_alw)}}</div>
                                    <div>{{formatMethods(item.incent_alw)}}</div>
                                </div>
                                <div class="detail" v-for="element in item.sc_prod_list" :key="element.sc_idx">
                                    <div><strong>└</strong> {{element.prod_name + "(" + element.prod_id +")"}}</div>
                                    <div>{{formatMethods(element.ori_fyp)}}</div>
                                    <div>{{formatMethods(element.incent_fyp)}}</div>
                                    <div>{{userPosition ? formatMethods(element.ori_pfm_c): formatMethods(element.ori_scr)}}</div>
                                    <div>{{userPosition ? formatMethods(element.incent_pfm_c): formatMethods(element.incent_scr)}}</div>
                                    <div>{{formatMethods(element.ori_alw)}}</div>
                                    <div>{{formatMethods(element.incent_alw)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="total">
                        <div colspan=2>小計</div>
                        <div>{{formatMethods(data.ori_fyp_sum)}}</div>
                        <div>{{formatMethods(data.incent_fyp_sum)}}</div>
                        <div>{{userPosition ? formatMethods(data.ori_pfm_c_sum): formatMethods(data.ori_scr_sum)}}</div>
                        <div>{{userPosition ? formatMethods(data.incent_pfm_c_sum): formatMethods(data.incent_scr_sum)}}</div>
                        <div>{{formatMethods(data.ori_alw_sum)}}</div>
                        <div>{{formatMethods(data.incent_alw_sum)}}</div>
                    </div>
                </div>
            </div>
            <!-- 底下說明 -->
            <div class="performaceResult__rmk mt_2">
                <div> 說明：</div>
                <ol class="remark_layout">
                    <li>
                        <span>本業績換算結果為「單一經手人」之情況。</span>
                    </li>
                    <li>
                        <span>本換算結果使用匯率如下：美元{{ exchangeMoney.USD }}元、紐幣{{ exchangeMoney.NZD}}元、澳幣{{ exchangeMoney.AUD }}元、人民幣{{ exchangeMoney.CNY }}元。</span>
                    </li>
                    <li>
                        <span>若匯率換算台幣與業績欄位有小數位，則四捨五入進位到整數位，例如：2,060.56元，四捨五入為2,061元。</span>
                    </li>
                    <li>
                        <span>新契約「受理日期」須在獎勵辦法之「實施期間」內始適用。</span>
                    </li>
                    <li>
                        <span>主約加發獎勵金核發比例係依獎勵商品之主約第 1 保單年度實收保費核發獎勵金；</span>
                    </li>
                    <div>附約加發獎勵金則依該附約第 1 保單年度實收保費核發獎勵金。</div>
                    <div>加發獎勵金不計入專招業績FYC及展業業績分數。</div>
                </ol>
            </div>
            <FixedBottom>
                <template slot="@function">
                <div class="d-flex justify-content-end mr_15">
                    <router-link
                    class="btn btn-default"
                    to="/mf/performace/recommendedProduct"
                    >重新選擇換算商品</router-link>
                    <router-link
                        class="btn btn-default px_5 mr_10"
                        to="/mf/query/queryDetail"
                        >查詢其他建議書</router-link>
                </div>
                </template>
            </FixedBottom>
        </div>
       <MfLoading :open="!is_ready" content="資料讀取中..." />
   </main>
</template>
<script>
import { mapGetters } from "vuex";
import MfLoading from "@/desktop/views/mf/components/MfLoading";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
export default {
    components: { MfLoading, FixedBottom },
    data(){
        return{
            listData:"",
            proposalList:[],
            proposalData:[],
            exchangeMoney:{},
            isLoading: true,
            is_ready: false,
            fakeDivNo: "9400400" //因應專展合併，一律用通路科代號(同專招身分)查詢業績試算
        }
    },
    computed:{
    ...mapGetters(["UserInfo",  "PerfomaceProposal"]),
    userPosition(){
        // UserInfo.divNo === "4" 為展業，其餘為專招
        return (/true/).test(this.fakeDivNo.substr(2,1) !== "4")
    },
    userWorkDate(){
        return this.UserInfo.workDate.substr(0,5)
    }
    },
    mounted() {
        this.performaceInit();
    },
    methods:{
        formatMethods(source = "") {
            let sourceString = source + "";
            let FloatString = sourceString == "" ? "" : Math.ceil(parseFloat(sourceString)).toFixed(0);
            return FloatString !== "" ? FloatString.split("") 
                                                  .reverse().map((char, i) => {
                                                    return i % 3 == 0 && i != 0 ? char + "," : char;})
                                                  .reverse().join(""): "異常"
        },
        performaceInit(){
            this.proposalList.push(this.PerfomaceProposal)
            this.listData = JSON.parse(JSON.stringify(this.proposalList))
            this.$mfAPI.MFC0_1005__getCommission({
                userInfo: {
                    id: this.UserInfo.id,
                    divNo: this.fakeDivNo,
                    position: this.UserInfo.position,
                    workDate: this.UserInfo.workDate
                },
                proposalList: this.listData
                }).then(res=>{
                    this.is_ready= true
                    this.proposalData =res.cmn_list;
                    const proposalAddOrder =this.proposalData[0].mc_prod_list.map((obj,index)=>{
                        return {...obj, order:this.listData[0].mc_prod_list[index].order}
                    })
                    this.proposalData[0].mc_prod_list = proposalAddOrder
                    this.exchangeMoney=res.exchange_rates
                    this.isLoading = false
            
                })
        },
    },

}
</script>
<style  lang="scss" scoped>
.text_row_Indent{
    text-indent: 1em;
}

.remark_layout{
    margin: 0;
    padding-left: 20px;
}

.performaceNewResultItem {
  max-width: 1200px;
  width: 100%;
  border-radius: 4px;
  border: solid 2px #53c480;
  margin-top: 30px;
  &__header {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
  }
  &__title {
    width: 100%;
    display: flex;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
    border-top: solid 2px rgba(194, 196, 199, 0.8);
    & > div {
      border-right: solid 2px rgba(194, 196, 199, 0.8);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      & >.text_colum{
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;
        border-top: solid 2px rgba(194, 196, 199, 0.8);
        & > div:nth-of-type(1) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
            border-right: solid 2px rgba(194, 196, 199, 0.8);
        }
        & > div:nth-of-type(2) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
        }
        & > .word_length{
            white-space: nowrap;
        }
      }
    }
    & > div:nth-of-type(1) {
        min-height: 50px;
        width: 9%;
        padding: 3px 7px;
    }
    & > div:nth-of-type(2) {
        width: 31%;
    }
    & > div:nth-of-type(3) {
        width: 20%;
        & > div:nth-of-type(1) {
            padding: 3px 7px;
        }
    }
    & > div:nth-of-type(4) {
        width: 20%;
        & > div:nth-of-type(1) {
            padding: 3px 7px;
            }
    }
    & > div:nth-of-type(5) {
        width: 20%;
        border-right:none;
      & > div:nth-of-type(1) {
            padding: 3px 7px;
        }
    } 
  }
  &__row {
    width: 100%;
    display: flex;
    flex-direction: column;
    color: #323a45;
    background-color: #fff;
    & > .table{
        display: flex;
        flex-direction: row;
        /* width: 100%; */
        & > div:nth-of-type(1) {
            border-right: solid 2px rgba(194, 196, 199, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px 7px;
            width: 9%;
            }
        & > .number_border{
            border-top: solid 2px rgba(194, 196, 199, 0.8);
        }
        & > .layout{
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        & > .contact{
            display: flex;
            flex-direction: column;
            line-height: 25px;
            & > div:nth-of-type(1) {
                padding: 3px 7px;
                color: blue;
                font-weight: bold;
                border-top: solid 2px rgba(194, 196, 199, 0.8);
                flex-grow:1;
            }
            & > .main {
                display: flex;
                flex-direction: row;
                align-items: center;
                text-align: center;
                line-height: 25px;
                & > div{
                    padding: 3px 7px;
                    border-right: solid 2px rgba(194, 196, 199, 0.8);
                    border-top: solid 2px rgba(194, 196, 199, 0.8); 
                    text-align: right;
                    word-break: break-all;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    box-sizing: border-box;
                }
                & > div:nth-of-type(1) {
                    width: 34%;
                    text-align: left;
                    align-items: center;
                    justify-content: flex-start;
                    }  
                & > div:nth-of-type(2) {
                    flex:1;
                    }
                & > div:nth-of-type(3) {
                    flex:1;
                    color: blue;
                    font-weight: 500;
                    }
                & > div:nth-of-type(4) {
                    flex:1;
                    }
                & > div:nth-of-type(5) {
                    flex:1;
                    color: blue;
                    font-weight: 500;
                    }
                & > div:nth-of-type(6) {
                    flex:1;
                    }
                & > div:nth-of-type(7) {
                    flex:1;
                    border-right: 0;
                    color: blue;
                    font-weight: 500;
                    }
                }
            & > .detail {
                display: flex;
                align-items: center;
                border-top: solid 2px rgba(194, 196, 199, 0.8);
                line-height: 25px;
                & > div{
                    padding: 3px 7px;
                    border-right: solid 2px rgba(194, 196, 199, 0.8);
                    text-align: right;
                    background-color: #f5f5f5;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    box-sizing: border-box;
                }
                & > div:nth-of-type(1) {
                    width: 34%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    text-align-last: start;
                    word-break: break-all; // for附約 字數過多要換行
                    }   
                & > div:nth-of-type(2) {
                    flex:1;
                    white-space:nowrap; // for數字 字數過多也不要換行
                    }
                & > div:nth-of-type(3) {
                    flex:1;
                    color: blue;
                    font-weight: 500;
                    white-space:nowrap;
                    }
                & > div:nth-of-type(4) {
                    flex:1;
                    white-space:nowrap;
                    }
                & > div:nth-of-type(5) {
                    flex:1;
                    color: blue;
                    font-weight: 500;
                    white-space:nowrap;
                    }
                & > div:nth-of-type(6) {
                    flex:1;
                    white-space:nowrap;
                    }
                & > div:nth-of-type(7) {
                    flex:1;
                    border-right: 0;
                    color: blue;
                    font-weight: 500;
                    white-space:nowrap;
                    }
                }
            }
        }
    }
    &> .total{
        display: flex;
        flex-direction: row;
        align-items: center;
        border-top: solid 1px rgba(194, 196, 199, 0.8);
        width: 100%;
        background-color: #fff3c2;
        line-height: 25px;
        & > div{
            padding: 3px 7px;
            font-weight: 700;
            border-right: solid 2px rgba(194, 196, 199, 0.8);
            border-top: solid 1px rgba(194, 196, 199, 0.8);
            text-align: right;
            white-space:nowrap;
            box-sizing: border-box;
        }
        & > div:nth-of-type(1) {
            width: 39.95%;
            font-weight: bold;
            display: flex;
            justify-content: flex-start;
        }   
        & > div:nth-of-type(2) {
            flex:1;
             display: flex;
            justify-content: flex-end;
        }
        & > div:nth-of-type(3) {
            flex:1;
            color: blue;
            display: flex;
            justify-content: flex-end;
            }
        & > div:nth-of-type(4) {
            flex:1;
            display: flex;
            justify-content: flex-end;
            }
        & > div:nth-of-type(5) {
            flex:1;
            color: blue;
            display: flex;
            justify-content: flex-end;
            }
        & > div:nth-of-type(6) {
            flex:1;
            display: flex;
            justify-content: flex-end;
            }
        & > div:nth-of-type(7) {
            flex:1;
            border-right: 0;
            color: blue;
            display: flex;
            justify-content: flex-end;
            }
        }
  }
}

</style>